import toDate from './toDate'

const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const DIAS = ['Domingo ', 'Lunes ', 'Martes ', 'Miércoles ', 'Jueves ', 'Viernes ', 'Sábado ']

export default function isoDateToWeekday(date) {
  return DIAS[toDate(date).getDay()] + parseInt(date.substring(8, 10)) + ' de ' + MESES[parseInt(date.substring(5, 7)) - 1]
}